<template>
  <SpectreHeading
    :as="as"
    color="light"
    size="sm"
  >
    <slot />
  </SpectreHeading>
</template>

<script lang="ts" setup>
import { SpectreHeading } from '@agentsoftware/spectre-ui';

defineProps<{
  as: string;
}>();
</script>
